import documento from "../../assets/sueldoInteligente/documento.png";
import flechasCirculo from "../../assets/sueldoInteligente/flechasCirculo.png";
import llave from "../../assets/sueldoInteligente/llave.png";
import reloj from "../../assets/sueldoInteligente/reloj.png";

export default function Section1() {
  return (
    <div className="bg-[#e8f2f4] py-16">
      <h2 className="text-4xl font-bold text-[#033d8e] text-center mb-14" style={{ textShadow: '0px 2px 5px rgba(0,0,0,0.3)' }}>
        Beneficios
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-20 gap-y-10 max-w-6xl mx-auto px-4">
        <div style={{ boxShadow: '0px 10px 10px rgba(0,0,0,0.35)' }} className="bg-[#e8f2f4] py-6 px-20 rounded-3xl text-center">
          <h3 className="text-xl font-bold text-[#033d8e] mb-4">Fácil y automático:</h3>
          <img src={reloj} alt="Reloj" className="w-14 mx-auto mb-4" />
          <p className="text-[#033d8e] font-bold">
            Gestiona tu inscripción al Abono Automático a través de MEU, la línea telefónica de comercio internacional o en las sucursales físicas.
          </p>
        </div>

        <div style={{ boxShadow: '0px 10px 10px rgba(0,0,0,0.35)' }} className="bg-[#0054c9] py-6 px-20 rounded-3xl text-center">
          <h3 className="text-xl font-bold text-white mb-4">Sin papeleo adicional:</h3>
          <img src={documento} alt="Documento" className="w-14  mx-auto mb-4" />
          <p className="text-[#ccddf6] font-bold">
            No necesitas enviar documentación extra para activar el servicio de Abono Automático.
          </p>
        </div>

        <div style={{ boxShadow: '0px 10px 10px rgba(0,0,0,0.35)' }} className="bg-[#0054c9] py-6 px-20 rounded-3xl text-center">
          <h3 className="text-xl font-bold text-white mb-4">Proceso sencillo:</h3>
          <img src={flechasCirculo} alt="Proceso" className="w-14 mx-auto mb-4" />
          <p className="text-[#ccddf6] font-bold">
            Una vez inscrito, recibirás giros automáticamente y podrás disponer de tu dinero al instante.
          </p>
        </div>

        <div style={{ boxShadow: '0px 10px 10px rgba(0,0,0,0.35)' }} className="bg-[#e8f2f4] py-6 px-20 rounded-3xl text-center">
          <h3 className="text-xl font-bold text-[#033d8e] mb-4">Mayor seguridad:</h3>
          <img src={llave} alt="Seguridad" className="w-14 mx-auto mb-4" />
          <p className="text-[#033d8e] font-bold">
            Recibe tus giros de forma confiable y directa en tu cuenta, evitando posibles errores o pérdidas de dinero.
          </p>
        </div>
      </div>
    </div>
  );
}